// style
import "./DetailPost.scss";
import "pages/Blog/Blog.scss";
import eikia from "assets/images/logo/logo.png";

// react
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Helmet } from "react-helmet";

// component
import { pathMaker } from "utils/helperFunctions.js";
import useAxios from "services/useAxios.tsx";
import Article from "pages/Blog/Article.jsx";
import Loader from "components/kits/Loader/Loader.tsx";

export default function DetailPost() {
  const param = useParams();

  // state
  const [tags, setTags] = useState([]);
  const [infoBlog, setInfoBlog] = useState();
  const [relatedBlog, setRelatedBlog] = useState([]);
  const { loading: getPostLoading, execute: getBlogApi } =
    useAxios("api/getsinglepost");
  const getBlog = () => {
    getBlogApi({ postId: param.id }).then((res) => {
      setInfoBlog(res.post);
      setTags(res?.post?.hashtags);
      setRelatedBlog(res.similar_posts);
    });
  };
  // function
  const convertTimestampToDate = (timeStamp) => {
    const date = new DateObject({
      date: +timeStamp * 1000,
      calendar: persian,
    });
    let showDate;
    timeStamp != "" ? (showDate = date.format()) : (showDate = "-");
    return showDate;
  };
  useEffect(() => {
    getBlog();
  }, [param]);

  return getPostLoading ? (
    <div
      className="w-100 d-flex align-items-center justify-content-center"
      style={{ margin: "150px 0" }}
    >
      <Loader width={40} />
    </div>
  ) : (
    <div className="p-detail-post container" style={{ marginTop: "12px" }}>
      <Helmet>
        <title>پت شاپ / {infoBlog?.title ?? ""}</title>
      </Helmet>
      <div className="box-cover d-flex">
        <img
          className="box-img col-10 col-md-6 h-auto mx-auto"
          src={
            infoBlog?.file[0]?.url ? pathMaker(infoBlog?.file[0]?.url) : eikia
          }
        ></img>
        {/*{auth.userInfo?.userType == 0 && (*/}
        {/*    <div className="position-relative">*/}
        {/*        <AdminOperationArticle isPost={true} ArticleData={infoBlog} id={param.id}/>*/}
        {/*    </div>*/}
        {/*)}*/}
      </div>

      <div className="box-body">
        <div className="box-detail">
          <div className="d-flex detail">
            <div className="sub-title">{infoBlog?.title} </div>
          </div>
          <div className="d-flex detail">
            <div className="sub-title ">
              {" "}
              {infoBlog?.mtm != ""
                ? convertTimestampToDate(infoBlog?.mtm)
                : "- - -"}
            </div>
          </div>
        </div>
        <div
          className="desc"
          dangerouslySetInnerHTML={{ __html: infoBlog?.bodytxt }}
        >
          {/* {infoBlog?.bodytxt.replace(`<p>`, "")} */}
        </div>

        <div className="box-tags">
          {tags?.map((val, ind) => {
            if (val.type === null) return;
            return (
              <NavLink
                style={{ textDecoration: "none", color: "black" }}
                to={`/blog/${val.hashtags_id}`}
              >
                {val.txt !== null ? (
                  <div className="btn btn-outline-primary font-14-500 tags">
                    {val.txt}
                  </div>
                ) : (
                  ""
                )}
              </NavLink>
            );
          })}
        </div>
      </div>
      <div className="box-related my-3">
        <div className="title-related ">مقالات مرتبط</div>
        <Swiper
          breakpoints={{
            // when window width is >= 640px
            320: {
              width: 220,
              slidesPerView: 1,
            },
            // when window width is >= 768px
            768: {
              width: 620,
              slidesPerView: 3,
            },
          }}
          spaceBetween={10}
          slidesPerView={4}
        >
          {" "}
          <div className="d-flex">
            {relatedBlog?.map((val) => {
              return (
                <SwiperSlide className="article-list">
                  <Article article={val} isSize={true} />
                </SwiperSlide>
              );
            })}
          </div>
        </Swiper>
      </div>
    </div>
  );
}
